import { Background } from './pages/background'
import { Page } from './pages/page'
import { Organization } from '@tixa/schema'
import { getPageData } from './utils/ajax'

import './components/list-event/list-event'
import './components/page-sidebar/page-sidebar'
import './components/subpage-header/subpage-header'

import './components/item-event/item-event.less'
import './organizer.less'

export class OrganizerPage extends Page {
  public title: string
  public logo: string | null = null
  public image: string | null = null
  public hasImage = false

  constructor() {
    super()

    const org = getPageData<Organization>('organizerData')
    if (org) {
      this.title = org.name

      if (org.image) {
        this.image = org.image
        this.hasImage = true
      } else {
        Background.getInstance().setDefaultBackground()
      }
      if (org.logo) {
        this.logo = org.logo
      }
    } else {
      // Handle the case where org is undefined
      this.title = 'Default Title'
      Background.getInstance().setDefaultBackground()
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const page = new OrganizerPage()
